import { ref, toValue, watchEffect, type MaybeRef } from "vue";

export function useWaitForSelector(
  selector: MaybeRef<string | null>,
  watcher: (el: Element) => void,
) {
  const mutationObserver = ref<MutationObserver | null>(null);

  function cleanup() {
    mutationObserver.value?.disconnect();
    mutationObserver.value = null;
  }

  async function watchSelector(selectorValue: string) {
    const el = document.querySelector(selectorValue);
    if (el) {
      return watcher(el);
    }

    const observer = new MutationObserver(() => {
      const el = document.querySelector(selectorValue);
      if (el) {
        watcher(el);
        cleanup();
      }
    });
    mutationObserver.value = observer;

    // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  watchEffect((onCleanup) => {
    const selectorValue = toValue(selector);
    if (!selectorValue) return;

    watchSelector(selectorValue);

    onCleanup(cleanup);
  });
}
